import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { EmployeeDataModel, EmployeeModel, DataViewEnum, ColumnModel } from '../models';
import { setFormattedData, addOrUpdateData } from '../helpers/helper';

export interface employeestate {
  dataView: DataViewEnum;
  data: EmployeeDataModel;
}

const initialState: employeestate = {
  dataView: DataViewEnum.List,

  data: {
    recordCount: 0,
    records: [],
    rawData: [],
    columns: []
  },
};

const uniqueDataKey = "employeeId";

const columnConfig: Record<string, Partial<ColumnModel>> = {
  primaryKeyId: {
      width: 60,
      formatter: (record: EmployeeModel) => record.employeeId
  },
  firstName: { width: 200 },
  middleName: { width: 200 },
  lastName: { width: 200 },
  position: { width: 200 },
  phone: { width: 180 },
  email: { width: 200 },
  address: {
    hasTooltip: true,
    flexGrow: 1
  }
};

export const employeesSlice = createSlice({
  name: 'employees',
  initialState,
  reducers: {
    setDataView: (state, action: PayloadAction<DataViewEnum>) => {
      state.dataView = action.payload;
      return state;
    },
    setEmployeesData: (state, action: PayloadAction<EmployeeModel[]>) => {
      state.data = setFormattedData({ rawData: action.payload }, columnConfig, uniqueDataKey);
    },
    setEmployee: (state, action: PayloadAction<EmployeeModel>) => {
      addOrUpdateData(state.data, action.payload, columnConfig, uniqueDataKey);
      return state;
    },
    removeEmployee: (state, action: PayloadAction<number>) => {
      state.data.records = state.data.records.filter(record => record[uniqueDataKey] !== action.payload);
      state.data.rawData = state.data.rawData.filter(raw => raw[uniqueDataKey] !== action.payload);
      return state
    },
    setLogoutEmployees: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { setDataView, setEmployeesData, setEmployee, removeEmployee, setLogoutEmployees } = employeesSlice.actions;

export default employeesSlice.reducer;